export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8128.22f159b7.jpg";